export const messages = {
  defaultFailureMessage: {
    title: 'Something Went Wrong',
    text: 'Please try again later.',
  },
} as const
